module.exports = __webpack_public_path__ + "static/media/worker 1.406c6be0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/worker 1.svg
// module id = 3204
// module chunks = 0